module.exports = __webpack_public_path__ + "static/media/tow_car.306bb3ac.jpg";